
import { useEffect } from 'react';

interface ToastProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose: () => void;
  duration?: number;
}

export default function Toast({ type, message, onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: 'ri-checkbox-circle-line',
    error: 'ri-close-circle-line',
    warning: 'ri-error-warning-line',
    info: 'ri-information-line'
  };

  const colors = {
    success: 'from-[#D4AF37] to-[#FFD700]',
    error: 'from-red-500 to-red-600',
    warning: 'from-yellow-500 to-yellow-600',
    info: 'from-blue-500 to-blue-600'
  };

  const bgColors = {
    success: 'bg-[#D4AF37]/10',
    error: 'bg-red-500/10',
    warning: 'bg-yellow-500/10',
    info: 'bg-blue-500/10'
  };

  const borderColors = {
    success: 'border-[#D4AF37]/50',
    error: 'border-red-500/50',
    warning: 'border-yellow-500/50',
    info: 'border-blue-500/50'
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-slide-in-right">
      <div className={`${bgColors[type]} backdrop-blur-md rounded-xl p-4 border ${borderColors[type]} shadow-2xl min-w-[300px] max-w-md`}>
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 bg-gradient-to-br ${colors[type]} rounded-full flex items-center justify-center flex-shrink-0`}>
            <i className={`${icons[type]} text-xl text-white`}></i>
          </div>
          <div className="flex-1">
            <p className="text-white text-sm leading-relaxed">{message}</p>
          </div>
          <button
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer flex-shrink-0"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
